import styles from "../App.module.css";
import { trackEvent } from "../analytics";

export const APP_STORE_URL = "https://apps.apple.com/us/app/creataai/id1659088194";

const homeAnchor = (fragment, isHome) => (isHome ? fragment : `/${fragment}`);

export const MarketingNav = ({ isHome = false, currentPage, showTopUp = true }) => (
  <nav className={styles.marketingNav} aria-label="Main navigation">
    <a className={styles.navBrand} href="/" aria-label="Creata AI home">
      <img src="/img/creataai_logo_white.png" width="42" height="35" alt="" />
      <span>Creata AI</span>
    </a>
    <div className={styles.navLinks}>
      <a href={homeAnchor("#how-it-works", isHome)}>How it works</a>
      <a
        href={homeAnchor("#privacy", isHome)}
        onClick={() => trackEvent("privacy_link_click", { placement: "navigation" })}
      >
        Privacy
      </a>
      {showTopUp && (
        <a
          className={currentPage === "topup" ? styles.navLinkCurrent : undefined}
          href="/topup"
          aria-current={currentPage === "topup" ? "page" : undefined}
        >
          Top up credits
        </a>
      )}
      <a
        className={currentPage === "support" ? styles.navLinkCurrent : undefined}
        href="/support"
        aria-current={currentPage === "support" ? "page" : undefined}
      >
        Support
      </a>
    </div>
    <a
      className={styles.navDownload}
      href={APP_STORE_URL}
      target="_blank"
      rel="noreferrer"
      onClick={() => trackEvent("app_store_click", { app_name: "Creata AI", placement: "navigation" })}
    >
      Download for iPhone
    </a>
  </nav>
);

export const MarketingFooter = ({ showTopUp = true }) => (
  <footer className={styles.siteFooter}>
    <span>© {new Date().getFullYear()} Creata AI</span>
    <div>
      {showTopUp && <a href="/topup">Top up credits</a>}
      <a href="/products">Our products</a>
      <a href="/support">Support</a>
      <a href="/privacy.html">Privacy</a>
    </div>
  </footer>
);
